import { Link } from '@tanstack/react-router';
import Images from '../Themes/Images';
import ErrorStyles from '../Containers/Styles/ErrorStyles';

type Props = {
  code: '404' | '403';
  title: string;
  message: string;
};

function ErrorPage({ code, title, message }: Props) {
  return (
    <div style={ErrorStyles.verticalCenter}>
      <div className="error-page-container">
        <div style={ErrorStyles.errorHeader}>
          <img style={ErrorStyles.errorHeaderImg} src={Images.xvivoSymbolSvg} alt="" />
          {code} — {title}
        </div>
        <div style={ErrorStyles.outerWrapper}>
          <div style={ErrorStyles.innerWrapper}>
            <div style={ErrorStyles.errorTitle}>{title}</div>
            <div style={{ ...ErrorStyles.errorMessage, marginTop: '1rem' }}>
              <p style={ErrorStyles.errorMessageFirstLine}>{message}</p>
            </div>
            <div style={{ marginTop: '2rem' }}>
              <Link
                to="/login"
                style={{
                  display: 'inline-block',
                  padding: '0.6rem 1.4rem',
                  backgroundColor: 'var(--interact, #275880)',
                  color: '#fff',
                  textDecoration: 'none',
                  borderRadius: 4,
                  fontSize: 14,
                }}
              >
                Go to Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage;
